//Componente importado de material ui
import { makeStyles } from '@material-ui/core/styles';
//Estilo genérico importado
import { estilosTextosPrincipales, colores } from '../../../AppStyle';

export default makeStyles({
    root: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '3%',
      marginBottom: '3%',
      width: '90%'
    },
    cardAndSegura: {
      width: '100%',
      maxWidth: '100%',
      maxHeigth: '100%',
    },
    media: {  
      paddingTop: '200px',
      backgroundSize: 'contain !important',
      width: '35%'
    },
    mediaMovil: {  
      paddingTop: '200px',
      backgroundSize: 'contain !important',
    },
    classEncabezado: {
      ...estilosTextosPrincipales.encabezadoH2,
      color: colores.escalaGrises.cien,
      marginBottom: '25px'   
  },
  classEncabezadoH3: {
      ...estilosTextosPrincipales.encabezadoH3,
      color: colores.escalaGrises.cien,
      lineHeight: '35px', 
      marginLeft: '20px',     
  },
  classParrafo: {
      ...estilosTextosPrincipales.body2,
      color: colores.escalaGrises.cien,
      letterSpacing: '0',
      lineHeight: '19px',
  },
  classParrafoBold: {
    ...estilosTextosPrincipales.body1,
    color: colores.escalaGrises.cien,
    fontWeight: 'bold',
    letterSpacing: '0',
    lineHeight: '19px',
},
  classLine: {
    boxSizing: 'borderBox',
    height: '1px',
    width: '100%',
    border: '1px',
    borderStyle: 'solid',
    borderColor: '#D5D4D4',
    marginTop: '13px',
    marginBottom: '23px',
  },
  classBackdrop: {
    zIndex: 1,
    color: '#fff',
  }
});